import { CloudPremisePluginManager } from "@cloudpremise/portal_core";
import ServiceDeskPlugin from "./servicedesk";
import FirebasePlugin from "./firebase";
import BpmPlugin from "./bpm";
import AuthPlugin from "./auth";
import AllPlugin from "./all";
import FileManagerPlugin from "./filemanager";
import DemoPlugin from "./demo";
import IrisPlugin from "./iris";
import HestiaPlugin from "./hestia";
import FormPlugin from "./form";
import MapPlugin from "./map";
import AdminPlugin from "./admin";
//NewPluginsImportPlaceHolder
//Reactforce cli would insert import line for future plugins

const plugins = [];
if(AdminPlugin.status){ plugins.push(AdminPlugin); };
if(DemoPlugin.status){ plugins.push(DemoPlugin); }
if(FirebasePlugin.status){ plugins.push(FirebasePlugin); }
if(ServiceDeskPlugin.status){ plugins.push(ServiceDeskPlugin); }
if(BpmPlugin.status){ plugins.push(BpmPlugin); }
if(AuthPlugin.status){ plugins.push(AuthPlugin); }
if(FileManagerPlugin.status){ plugins.push(FileManagerPlugin); }
if(AllPlugin.status){ plugins.push(AllPlugin); }
if(IrisPlugin.status){ plugins.push(IrisPlugin); };
if(HestiaPlugin.status){ plugins.push(HestiaPlugin); };
if(FormPlugin.status){ plugins.push(FormPlugin); };
if(MapPlugin.status){ plugins.push(MapPlugin); };
//NewPluginsPushPlaceHolder
//Reactforce cli would add a plugins.push line for future plugins.
//Both above placeholders are for cli to use so don't ever modify these or remove them.
const PluginManager = new CloudPremisePluginManager(plugins);

export default PluginManager;